"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProps = void 0;
var React = __importStar(require("react"));
var icons_1 = require("@epic-ui/icons");
var Fade_1 = __importDefault(require("@material-ui/core/Fade"));
var utils_1 = require("@material-ui/utils");
var createProps = function (options) {
    if (options === void 0) { options = {}; }
    var defaultProps = {
        MuiAlert: {
            variant: "filled",
            iconMapping: {
                success: React.createElement(icons_1.StatusApproved, null),
                warning: React.createElement(icons_1.StatusAlert, null),
                error: React.createElement(icons_1.StatusEscalated, null),
            },
        },
        MuiButton: {
            variant: "contained",
            color: "primary",
            disableElevation: true,
        },
        MuiButtonBase: {
            disableRipple: true,
        },
        MuiButtonGroup: {
            variant: "contained",
            color: "primary",
            disableRipple: true,
        },
        MuiCheckbox: {
            color: "primary",
            checkedIcon: React.createElement(icons_1.CheckboxChecked, null),
            indeterminateIcon: React.createElement(icons_1.CheckboxIndeterminate, null),
            icon: React.createElement(icons_1.CheckboxUnchecked, null),
        },
        MuiChip: {
            deleteIcon: React.createElement(icons_1.Close, null),
        },
        MuiCircularProgress: {
            thickness: 4,
        },
        MuiDialogTitle: {
            disableTypography: true,
        },
        MuiInputAdornment: {
            disableTypography: true,
        },
        MuiList: {
            disablePadding: true,
        },
        MuiLink: {
            color: "textPrimary",
            underline: "always",
        },
        MuiOutlinedInput: {
            notched: false,
        },
        MuiTextField: {
            variant: "outlined",
        },
        MuiMenu: {
            elevation: 0,
            TransitionComponent: Fade_1.default,
            PaperProps: {
                variant: "outlined",
            },
        },
        MuiPagination: {
            shape: "rounded",
            size: "large",
        },
        MuiSelect: {
            variant: "outlined",
            MenuProps: {
                getContentAnchorEl: null,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                },
            },
            IconComponent: icons_1.ArrowFillDown,
        },
        MuiSwitch: {
            color: "primary",
        },
        MuiRadio: {
            color: "primary",
            checkedIcon: React.createElement(icons_1.RadioButtonChecked, null),
            icon: React.createElement(icons_1.RadioButtonUnchecked, null),
        },
        MuiTableSortLabel: {
            IconComponent: icons_1.ArrowFillDown,
        },
    };
    return utils_1.deepmerge(defaultProps, options, { clone: false });
};
exports.createProps = createProps;
//# sourceMappingURL=createProps.js.map